import BasicText from "../../BasicText";
import LButton from "../../LButton";
import Subtitle from "../../Subtitle";
import Title from "../../Title";
import Skribble from "../../svg/Skribble";
import rocketship from '@/assets/images/ASCII/Group 182.png';
import AsciiArt from "../../AsciiArt";
import MissionClippedSquareBox from "../../svg/MissionClippedSquareBox";
import MissionBoxlet from "../../MissionBoxlet";
import DotEffect from "../../svg/DotEffect";

function OurMission({ ref0 }: any) {
  return (
    <div ref={ref0} className="relative flex flex-col items-start justify-start w-full xl:w-[1200px] gap-[70px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0">
      <div>
        <Subtitle>
          <div className="pb-[12px]">
            // Our mission
          </div>
        </Subtitle>
        <Title>
          <div>
            Luminode&apos;s mission
          </div>
          <div className="flex flex-row">
            is to&nbsp;<div className="text-luminode-blue">redefine web3</div>
          </div>
        </Title>
      </div>
      <div className="absolute left-[440px] top-[350px] pointer-events-none">
        <DotEffect />
      </div>
      <div className="flex flex-row gap-[20px] w-full xl:w-[1200px]">
        <div className="w-full xl:w-[500px] h-[630px] pt-[40px] hidden xl:flex items-center justify-center">
          <AsciiArt src={rocketship} />
        </div>
        <div className="flex flex-col justify-start items-start grow gap-4">
          <div className="pt-[30px] pb-[50px]">
            <BasicText>
              <div className="text-[12px] xl:text-[18px] max-w-[580px]">
                <div>Our mission is to elevate blockchain development by
                  addressing past flaws and propelling it into the next
                  stage with enhanced security and efficiency.</div>
              </div>

            </BasicText>
          </div>
          {/*
          <div className="flex flex-row items-center justify-start w-full xl:w-[570px]">
            <MissionBoxlet>
              <div className="text-[#9494A8] text-[13px] uppercase opacity-50">raised</div>
              <div className="text-white text-[32px]">$XXXm+</div>
            </MissionBoxlet>
          </div>
          <div className="flex flex-row items-center justify-end w-full xl:w-[570px]">
            <MissionBoxlet>
              <div className="text-[#9494A8] text-[13px] uppercase opacity-50">users</div>
              <div className="text-white text-[32px]">XXXm+</div>
            </MissionBoxlet>
          </div>
          <div className="flex flex-row items-center justify-start w-full xl:w-[570px]">
            <MissionBoxlet>
              <div className="text-[#9494A8] text-[13px] uppercase opacity-50">transactions</div>
              <div className="text-white text-[32px]">$XXm+</div>
            </MissionBoxlet>
          </div>
  */}
        </div>
      </div >
    </div >
  );
}

export default OurMission;